import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

/* Taken from: https://reacttraining.com/react-router/web/guides/scroll-restoration */

class ScrollToTop extends React.Component {
  static propTypes = {
    location: PropTypes.shape({}),
    children: PropTypes.node
  };

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (location !== prevProps.location && !location.hash) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/components/ScrollToTop/index.js